import FsspScreen from './FsspScreen';

export default FsspScreen;
